import clsx from 'clsx'
import React, { useContext, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { KTSVG } from '../../../helpers'
import { Dropdown } from '../../../helpers/components/Dropdown'
import { useLayout } from '../../../layout/core'
import { createInitials } from '../../../utils/functions/createInitials'
import UserContext from '../../../context/UserContext'
import { maskEmail } from '../../../utils/functions/maskData'

const TopRightTools: React.FC = () => {
  const { config } = useLayout()
  const [isUserMenuOpen, setIsUserMenuOpen] = useState<boolean>(false)
  const headerUserDropdownMenuRef = useRef<HTMLDivElement>(null)
  const { currentUser, currentUserRole } = useContext(UserContext)
  const isFranchiseAdmin = currentUserRole.franchiseAdmin

  console.log()
  console.log('working')
  let initials = null
  if (!!currentUser.name) {
    initials = createInitials(currentUser.name)
  }

  const closeUserMenu = () => {
    setIsUserMenuOpen(false)
  }

  const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
    toolbarUserAvatarHeightClass = `symbol-30px symbol-md-40px ${
      isUserMenuOpen ? 'show menu-dropdown' : ''
    }`

  return (
    <>
      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        ref={headerUserDropdownMenuRef}
      >
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
        >
          <span className={`symbol-label bg-light-dark text-primary fs-6 fw-bolder`}>
            {initials?.label}
          </span>
        </div>
        {/* <UserMenu isUserMenuOpen={isUserMenuOpen} setIsUserMenuOpen={setIsUserMenuOpen} /> */}
        <Dropdown
          menuRef={headerUserDropdownMenuRef as React.RefObject<HTMLDivElement>}
          droppedDown={isUserMenuOpen}
          setDroppedDown={setIsUserMenuOpen}
        >
          <div className='card-body'>
            <div className='menu-content d-flex align-items-center px-3'>
              <div className='symbol symbol-50px me-5'>
                <span className={`symbol-label bg-light-dark text-primary fs-6 fw-bolder`}>
                  {initials?.label}
                </span>
              </div>

              <div className='d-flex flex-column'>
                <div className='fw-bolder d-flex align-items-center fs-5'>
                  {!!currentUser ? currentUser.name : 'Unknown User'}
                  {/* The following line will show the subscription status / plan details of the user */}
                  {/* <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span> */}
                </div>
                <span className='fw-bold text-muted text-hover-primary fs-7'>
                  {!!currentUser ? maskEmail(currentUser.email) : 'abc@xyz.com'}
                </span>
              </div>
            </div>
          </div>

          <div className='separator my-2'></div>

          {!isFranchiseAdmin && (
            <>
              <div className='menu-item px-5'>
                <Link to='/profile' onClick={closeUserMenu} className='menu-link px-5'>
                  My Profile
                </Link>
              </div>
              <div className='separator my-2'></div>
              {currentUser?.UserRole?.length > 0 && currentUser.UserRole[0]?.roleId === 1 && (
                <div className='menu-item px-5'>
                  <Link to='/subscription' onClick={closeUserMenu} className='menu-link px-5'>
                    View Plan
                  </Link>
                </div>
              )}
            </>
          )}

          {/* <div className='menu-item px-5 my-1'>
            <Link to={document.location} onClick={closeUserMenu} className='menu-link px-5'>
              Account Settings
            </Link>
          </div> */}

          <div className='menu-item px-5'>
            <Link to='/logout' className='menu-link px-5'>
              Sign Out
            </Link>
          </div>
        </Dropdown>
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </div>
        </div>
      )}
    </>
  )
}

export default TopRightTools
